import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'HIPAA Compliant Healthcare Software Development | RojrzTech',
    description: 'RojrzTech builds secure, HIPAA-compliant healthcare portals, telehealth apps, and EHR systems designed for modern medical practices and patient wellness.',
  },
  hero: {
    badge: 'HEALTHCARE SOLUTIONS',
    slides: [
      {
        heading: { pre: 'Build', gold: 'Patient-First Healthcare', post: 'Applications' },
        subheading: 'We develop secure, HIPAA-compliant patient portals, telehealth platforms, and practice management tools that streamline operations and elevate patient care.',
        pills: ['HIPAA', 'Telehealth', 'EHR System', 'Patient Portal', 'WebRTC'],
        image: '/Health.jpeg',
      },
      {
        heading: { pre: 'Virtual Care', gold: 'Telehealth Software Solutions' },
        subheading: 'Connect patients and clinicians anywhere with robust, high-definition video consultations, digital prescription logs, and smart appointment tools.',
        pills: ['Video Call', 'e-Prescription', 'HL7/FHIR Sync', 'Doctor App', 'Secure Chat'],
        image: '/Health1.jpeg',
      },
      {
        heading: { pre: 'Automated Medical', gold: 'Workflow Scheduling' },
        subheading: 'Reduce missed appointments by 80% and optimize clinical scheduling with intelligent dynamic booking, SMS notification reminders, and queue management.',
        pills: ['Booking Engine', 'SMS Alerts', 'Calendar Sync', 'Practice POS', 'Reports'],
        image: '/Health.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'PATIENT CARE PORTAL',
    phoneSubtitle: 'Secure patient services and instant doctor access.',
    tags: [
      { title: 'Automated Inquiry Follow-Up', desc: 'Respond to patient questions in under 5 minutes, every single time.' },
      { title: 'Local Search Visibility', desc: 'Show up in the Google Maps top 3 results for your specific medical specialty.' },
      { title: 'HIPAA Portal Security', desc: 'Fully encrypted data sharing protocols, protecting all patient records access.' },
      { title: 'Instant Booking System', desc: 'Allow patients to schedule digital telehealth sessions directly on your website.' },
      { title: 'Automated Reminders', desc: 'Minimize appointment no-shows via automated custom SMS and email alerts.' },
      { title: 'Seamless EHR Sync', desc: 'Integrate clinic workflows with legacy Electronic Health Record systems.' },
    ],
  },
  videoSection: {
    title: 'Next-Gen Telehealth System',
    subtitle: 'Witness our clean, secure digital clinic console and patient portal solution in action.',
    frameLabel: 'PATIENT WELLNESS DASHBOARD',
  },
  cards: {
    title: 'Comprehensive Healthcare Tech Services',
    subtitle: 'As a trusted medical software developer, we build applications that comply with global standards and streamline patient workflows.',
    items: [
      {
        icon: '🏥',
        title: 'Secure Telehealth Apps',
        description: 'Virtual doctor consultations with high-definition audio/video feeds, secure prescription integrations, and online patient consultation portals.',
      },
      {
        icon: '📊',
        title: 'EHR & EMR Database Sync',
        description: 'Securely sync patient histories, lab reports, and medication histories with industry-standard EHR databases to keep records unified.',
      },
      {
        icon: '⚡',
        title: 'Appointment Booking Engine',
        description: 'Automate doctor calendars, reduce admin workload, and enable patients to book, cancel, or reschedule medical checkups dynamically.',
      },
    ],
  },
  features: {
    title: 'Robust Medical Software Features Built For Clinic Growth',
    subtitle: 'Deploy customized healthcare modules that protect patient trust, optimize scheduling, and increase clinical revenues.',
    items: [
      'Secure Patient Data',
      'Telehealth Video',
      'Prescription Sync',
      'Medical Analytics',
      'HIPAA Safeguards',
      'Billing Gateway',
      'Provider Dashboard',
      'Patient History',
      'Smart Notifications',
      'Offline Logs',
      'Dynamic Forms',
      'Custom Reports',
    ],
  },
};

const Healthcare = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default Healthcare;
